import React from 'react';
var TimeoutWrapper = /** @class */ (function () {
    function TimeoutWrapper(callback, milli) {
        this.callback = callback;
        this.milli = milli;
    }
    TimeoutWrapper.prototype.start = function (milli) {
        var _this = this;
        this.clear();
        if (milli)
            this.milli = milli;
        if (this.callback && this.milli > 0) {
            this.interval = setTimeout(function () { return _this.callback(); }, this.milli);
        }
    };
    TimeoutWrapper.prototype.clear = function () {
        if (this.interval)
            clearTimeout(this.interval);
    };
    return TimeoutWrapper;
}());
export function useTimeout(callback, milli, autostart) {
    var interval = React.useRef(new TimeoutWrapper(callback, milli));
    React.useEffect(function () {
        if (autostart) {
            interval.current.start();
        }
    }, []);
    return interval.current;
}
;
